import { render, staticRenderFns } from "./JobItem.vue?vue&type=template&id=5cca01cd&scoped=true&"
import script from "./JobItem.vue?vue&type=script&lang=js&"
export * from "./JobItem.vue?vue&type=script&lang=js&"
import style0 from "./JobItem.vue?vue&type=style&index=0&id=5cca01cd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca01cd",
  null
  
)

export default component.exports